export const CURRENCY_OPTIONS = [
  { label: 'Рубль', value: 'RUB' },
  { label: 'Доллар', value: 'USD' },
  { label: 'Евро', value: 'EUR' },
];

export const STATUS_OPTIONS = [
  { label: 'Успешно', value: 'COMPLETED' },
  { label: 'Неудача', value: 'REJECTED' },
  { label: 'Возврат', value: 'REFUNDED' },
];
